import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { UserCareerPathType } from 'types';
import { formatCareerPathType } from 'shared-utils';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const roleOptions = Object.values(UserCareerPathType)?.map(el => ({
	label: formatCareerPathType(el),
	value: el,
}));

const RoleFilterInput = ({ showSelect = false }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const role = JSON.parse(searchParams.get('role') || '[]');

	const options = roleOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!role?.length}
					placeholder={'Role'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map(option => (
								<Button
									key={option?.value}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: role?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (role?.includes(option?.value?.toString())) {
											searchParams.set(
												'role',
												JSON.stringify(role?.filter((skill: string) => skill !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('role', JSON.stringify([...role, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									{option?.label}
									{role?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Role</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Software Developer"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => role?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('role', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default RoleFilterInput;
